import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Homepage from "./pages/homepage";
import NotFoundPage from "./pages/not-found-page";
import OrderPage from "./pages/order-page";
import FormBukberPage from "./pages/form-bukber";
import FormDataPelanggan from "./pages/form-data-pelanggan";
import FormReviewPage from "./pages/form-review-page";
import RingkasanPesanan from "./pages/ringakasan-pesanan";
import ReactGA from 'react-ga4';
import { useEffect } from "react";

ReactGA.initialize("G-VQYSKBB1TP");

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {    
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return null;
}

function App() {
  // const location = useLocation();

  // useEffect(() => {    
  //   ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  // }, [location]);

  return (
    <BrowserRouter>
      <AnalyticsTracker />
      
      <Routes>
        {/* <Route path="/" element={<Homepage />} /> */}
        <Route path="/" element={<Navigate to="/reservasi" replace />} />
        <Route path="/pre-order" element={<OrderPage />} />
        <Route path="/reservasi" element={<FormDataPelanggan />} />        
        <Route path="/menu" element={<FormBukberPage />} />
        <Route path="/order-review" element={<FormReviewPage />} />
        <Route path="/invoice" element={<RingkasanPesanan />} />

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
